<template>
  <div>
    <svg
      :style="{
        width: width || '40px',
        height: height || '40px',
      }"
      width="800px"
      height="800px"
      viewBox="-19.5 0 97 97"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <title>008-Redhair</title>
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Artboard" transform="translate(-183.000000, -706.000000)">
          <g id="008-Redhair" transform="translate(183.000000, 706.000000)">
            <path
              d="M49.48,56.6911 C49.816,55.9081 47.368,54.2061 45.318,54.3871 C44.211,54.4841 41.499,55.8981 41.499,55.8981 C41.499,55.8981 34.798,47.3841 34.098,47.1631 C33.398,46.9421 31.31,49.5151 31.31,49.5151 C31.31,49.5151 39.927,59.6491 41.333,60.1051 C43.77,60.8961 46.226,60.4761 46.561,60.0281 C46.897,59.5811 45.778,58.5371 45.778,58.5371 C45.778,58.5371 49.144,57.4741 49.48,56.6911"
              id="Fill-1182"
              fill="#F3B679"
            ></path>
            <path
              d="M27.03,37.8346 L31.31,49.5146 C34.218,48.0976 34.446,46.6186 34.256,45.8976 C33.174,41.7956 27.03,37.8346 27.03,37.8346"
              id="Fill-1184"
              fill="#EEA8B7"
            ></path>
            <path
              d="M34.0981,47.1631 C33.5461,46.9891 32.1351,48.5471 31.5611,49.2161 L31.9521,50.2821 C32.0041,50.3441 32.0561,50.4061 32.1141,50.4751 C33.9221,49.5781 34.6671,48.6611 34.9201,47.9291 C34.5151,47.4921 34.2141,47.2001 34.0981,47.1631"
              id="Fill-1186"
              fill="#D58F66"
            ></path>
            <path
              d="M31.3097,49.515 C34.2187,48.098 34.4457,46.619 34.2557,45.898 C34.1597,45.534 34.0217,45.171 33.8537,44.811 C33.0117,46.323 31.7467,47.365 30.7567,48.004 L31.3097,49.515 Z"
              id="Fill-1188"
              fill="#B55D75"
            ></path>
            <path
              d="M33.4523,58.5369 L25.9553,63.2859 C25.9553,63.2859 35.4903,68.7289 37.8503,68.7289 C40.2103,68.7289 46.3723,64.1989 45.1623,61.5209 C44.1493,59.2809 33.4523,58.5369 33.4523,58.5369"
              id="Fill-1190"
              fill="#463141"
            ></path>
            <path
              d="M49.17,77.536 L42.473,78.423 C42.473,78.423 40.478,81.901 40.745,83.803 C41.012,85.705 49.284,90.664 53.498,90.329 C57.712,89.993 57.973,86.152 57.674,84.623 C57.376,83.094 49.17,77.536 49.17,77.536"
              id="Fill-1192"
              fill="#EEA8B7"
            ></path>
            <path
              d="M41.8575,79.6199 C41.3915,80.5449 40.8605,82.3369 40.8605,82.3369 C41.2745,83.2949 43.5745,84.7179 43.5745,84.7179 C44.8745,81.5309 41.8575,79.6199 41.8575,79.6199"
              id="Fill-1194"
              fill="#FEFDFC"
            ></path>
            <path
              d="M55.0511,81.8713 C52.0181,84.8613 52.8131,88.6213 52.8131,88.6213 L53.2891,90.3373 C53.3591,90.3343 53.4301,90.3343 53.4981,90.3283 C57.7111,89.9933 57.9731,86.1523 57.6741,84.6233 C57.5671,84.0763 56.4451,83.0113 55.0511,81.8713"
              id="Fill-1196"
              fill="#FEFDFC"
            ></path>
            <path
              d="M51.0811,78.8709 C51.0811,78.8709 47.7551,81.6539 47.7551,82.1689 C47.7551,82.6839 49.0601,83.9409 49.7691,83.9409 C50.4771,83.9409 53.3301,80.5219 53.3301,80.5219 C52.6041,78.9189 51.0811,78.8709 51.0811,78.8709"
              id="Fill-1198"
              fill="#FEFDFC"
            ></path>
            <path
              d="M47.6671,74.8057 L44.1411,74.8107 C44.1411,74.8107 43.0851,74.8157 42.4511,75.3007 C41.8171,75.7857 41.6461,77.6127 42.6151,78.5827 C43.5851,79.5517 46.0681,79.9347 47.3081,79.3277 C49.0601,78.4707 49.7321,76.7547 49.3961,75.8607 C48.9491,74.6667 47.6671,74.8057 47.6671,74.8057"
              id="Fill-1200"
              fill="#D47087"
            ></path>
            <path
              d="M38.2097,61.7099 C38.2097,61.7099 35.1867,64.1119 35.3257,64.7869 C35.4647,65.4619 44.2257,68.2529 44.2257,68.2529 C44.2257,68.2529 43.8057,75.7209 44.4367,76.1959 C45.0667,76.6709 46.8697,76.7549 47.4287,75.7209 C47.7297,75.1639 48.9667,67.5819 48.2397,66.0719 C47.3207,64.1629 38.2097,61.7099 38.2097,61.7099"
              id="Fill-1202"
              fill="#F3B679"
            ></path>
            <path
              d="M54.542,88.7251 C50.549,89.0431 41.973,84.4381 40.86,82.3371 C40.74,82.8671 40.685,83.3751 40.745,83.8031 C41.012,85.7051 49.284,90.6641 53.498,90.3281 C55.807,90.1451 56.928,88.9081 57.421,87.5761 C56.774,88.1801 55.848,88.6211 54.542,88.7251"
              id="Fill-1204"
              fill="#FEFDFC"
            ></path>
            <path
              d="M33.4523,58.5369 L25.9553,63.2859 C25.9553,63.2859 32.1423,66.8169 35.7813,68.1889 L36.5373,68.4559 C39.8693,63.3939 43.4953,61.1869 45.2993,62.3079 C45.3043,62.0339 45.2733,61.7679 45.1623,61.5209 C44.1493,59.2809 33.4523,58.5369 33.4523,58.5369"
              id="Fill-1206"
              fill="#463141"
            ></path>
            <path
              d="M45.2991,62.3076 C45.3041,62.0346 45.2741,61.7676 45.1621,61.5206 C45.0551,61.2836 44.8351,61.0646 44.5351,60.8606 C39.7521,60.8216 36.4281,65.6266 35.1141,67.9246 C35.3441,68.0196 35.5681,68.1086 35.7821,68.1896 L36.5381,68.4556 C39.8701,63.3946 43.4951,61.1876 45.2991,62.3076"
              id="Fill-1208"
              fill="#D47087"
            ></path>
            <path
              d="M22.4117,62.5664 L16.2197,64.4374 C16.2197,64.4374 16.2797,69.3344 17.4837,71.0124 C18.6877,72.6904 24.2817,74.2004 27.0297,74.2004 C29.8187,74.2004 35.0307,71.3634 35.7667,70.0204 C36.5027,68.6784 36.0427,66.4794 35.3627,65.8544 C34.0037,64.6064 22.4117,62.5664 22.4117,62.5664"
              id="Fill-1210"
              fill="#463141"
            ></path>
            <path
              d="M37.9498,83.398 L31.2528,84.285 C31.2528,84.285 29.2578,87.763 29.5248,89.665 C29.7918,91.567 38.0638,96.526 42.2778,96.191 C46.4918,95.855 46.7528,92.014 46.4538,90.485 C46.1558,88.956 37.9498,83.398 37.9498,83.398"
              id="Fill-1212"
              fill="#EEA8B7"
            ></path>
            <path
              d="M30.6372,85.4819 C30.1712,86.4069 29.6402,88.1989 29.6402,88.1989 C30.0542,89.1569 32.3542,90.5799 32.3542,90.5799 C33.6542,87.3929 30.6372,85.4819 30.6372,85.4819"
              id="Fill-1214"
              fill="#FEFDFC"
            ></path>
            <path
              d="M43.8309,87.7333 C40.7979,90.7233 41.5929,94.4833 41.5929,94.4833 L42.0689,96.1993 C42.1389,96.1963 42.2099,96.1963 42.2779,96.1903 C46.4909,95.8553 46.7529,92.0143 46.4539,90.4853 C46.3469,89.9383 45.2249,88.8733 43.8309,87.7333"
              id="Fill-1216"
              fill="#FEFDFC"
            ></path>
            <path
              d="M39.8608,84.7329 C39.8608,84.7329 36.5348,87.5159 36.5348,88.0309 C36.5348,88.5459 37.8398,89.8019 38.5488,89.8019 C39.2568,89.8019 42.1098,86.3839 42.1098,86.3839 C41.3838,84.7809 39.8608,84.7329 39.8608,84.7329"
              id="Fill-1218"
              fill="#FEFDFC"
            ></path>
            <path
              d="M43.3217,94.5871 C39.3287,94.9051 30.7527,90.3001 29.6397,88.1991 C29.5197,88.7291 29.4647,89.2371 29.5247,89.6651 C29.7917,91.5671 38.0637,96.5261 42.2777,96.1901 C44.5867,96.0071 45.7077,94.7701 46.2007,93.4381 C45.5537,94.0421 44.6277,94.4831 43.3217,94.5871"
              id="Fill-1220"
              fill="#FEFDFC"
            ></path>
            <path
              d="M36.4468,80.6677 L32.9208,80.6727 C32.9208,80.6727 31.8648,80.6777 31.2308,81.1627 C30.5968,81.6477 30.4258,83.4747 31.3948,84.4447 C32.3648,85.4137 34.8478,85.7967 36.0878,85.1897 C37.8398,84.3327 38.5118,82.6167 38.1758,81.7227 C37.7278,80.5287 36.4468,80.6677 36.4468,80.6677"
              id="Fill-1222"
              fill="#D47087"
            ></path>
            <path
              d="M28.4339,68.1302 C28.4339,68.1302 25.4109,70.5322 25.5499,71.2072 C25.6889,71.8822 33.0049,74.1152 33.0049,74.1152 C33.0049,74.1152 32.5859,81.5822 33.2159,82.0582 C33.8469,82.5332 35.6499,82.6172 36.2089,81.5822 C36.5099,81.0262 37.7469,73.4442 37.0199,71.9342 C36.1009,70.0242 28.4339,68.1302 28.4339,68.1302"
              id="Fill-1224"
              fill="#F3B679"
            ></path>
            <path
              d="M22.4117,62.5664 L16.2197,64.4374 C16.2197,64.4374 16.2797,69.3344 17.4837,71.0124 C18.4467,72.3554 23.2457,73.9994 26.7247,74.1944 C31.3097,67.7124 36.0997,68.1434 36.1277,68.1304 C36.0427,67.0194 35.8387,66.2914 35.3627,65.8544 C34.0037,64.6064 22.4117,62.5664 22.4117,62.5664"
              id="Fill-1226"
              fill="#463141"
            ></path>
            <path
              d="M44.7524,60.5494 C44.7464,60.4594 44.7334,60.3724 44.7164,60.2864 C44.7334,60.3714 44.7454,60.4594 44.7524,60.5494"
              id="Fill-1228"
              fill="#E57472"
            ></path>
            <path
              d="M44.7374,61.0596 C44.7454,61.0046 44.7474,60.9506 44.7524,60.8966 C44.7484,60.9506 44.7434,61.0046 44.7374,61.0596"
              id="Fill-1230"
              fill="#E57472"
            ></path>
            <path
              d="M22.4117,35.4569 C14.3807,35.8669 12.9637,62.9019 14.5297,64.0209 C16.0957,65.1389 29.0697,64.7269 33.4527,58.5369 C34.6517,56.8429 30.4427,35.0469 22.4117,35.4569"
              id="Fill-1232"
              fill="#D47087"
            ></path>
            <path
              d="M19.3276,39.2816 C19.3276,39.2816 21.7306,42.0796 24.3706,41.5826 C27.0296,41.0826 26.4956,38.0176 26.4956,38.0176 L19.3276,39.2816 Z"
              id="Fill-1234"
              fill="#B55D75"
            ></path>
            <path
              d="M19.8083,38.1968 C19.8083,38.1968 21.8573,41.5298 24.3703,40.5828 C26.3693,39.8298 25.6763,36.9178 25.6763,36.9178 L19.8083,38.1968 Z"
              id="Fill-1236"
              fill="#EFA26E"
            ></path>
            <path
              d="M36.4971,29.6841 C33.3741,38.2831 19.1691,40.5921 15.4431,38.6261 C10.3291,35.9291 8.2841,28.7201 8.2841,28.7201 L8.2841,11.9661 L33.2401,8.9661 C33.2401,8.9661 38.4481,24.3111 36.4971,29.6841"
              id="Fill-1238"
              fill="#F3B679"
            ></path>
            <path
              d="M8.2837,13.5716 L34.3707,12.6256 C34.9397,14.5616 35.3917,16.1576 35.9477,18.8616 C30.2047,21.4926 24.8917,19.1106 24.8917,19.1106 C24.8917,19.1106 25.9007,21.1636 25.0667,22.4436 C22.8547,25.8336 11.1827,19.9346 7.8237,18.6856 L8.2837,13.5716 Z"
              id="Fill-1240"
              fill="#D58F66"
            ></path>
            <path
              d="M32.5705,24.7221 C32.5705,23.7841 33.1165,23.0231 33.7905,23.0231 C34.4645,23.0231 35.0105,23.7841 35.0105,24.7221 C35.0105,25.6601 34.4645,26.4211 33.7905,26.4211 C33.1165,26.4211 32.5705,25.6601 32.5705,24.7221"
              id="Fill-1242"
              fill="#050000"
            ></path>
            <path
              d="M20.5384,30.4493 C20.5384,29.5113 21.0844,28.7503 21.7584,28.7503 C22.4324,28.7503 22.9784,29.5113 22.9784,30.4493 C22.9784,31.3873 22.4324,32.1483 21.7584,32.1483 C21.0844,32.1483 20.5384,31.3873 20.5384,30.4493"
              id="Fill-1244"
              fill="#050000"
            ></path>
            <path
              d="M20.2545,35.2943 C20.2545,34.0713 19.4285,33.0793 18.4085,33.0793 C17.3895,33.0793 16.5625,34.0713 16.5625,35.2943 C16.5625,36.5173 17.3895,37.5093 18.4085,37.5093 C19.4285,37.5093 20.2545,36.5173 20.2545,35.2943"
              id="Fill-1246"
              fill="#EB8E71"
            ></path>
            <path
              d="M17.3654,54.3109 C17.0274,53.7659 14.1754,52.9619 13.5694,53.4019 C12.9634,53.8409 9.0854,70.4349 9.0854,70.4349 C9.0854,70.4349 5.7674,70.8259 4.4624,72.6159 C3.1574,74.4059 5.3274,75.9859 7.1174,76.2839 C8.9074,76.5829 11.6594,74.3699 11.6594,74.3699 C11.6594,74.3699 12.7254,74.8569 13.8104,74.8789 C14.8964,74.9009 15.8614,74.2819 15.7494,73.6849 C15.6374,73.0889 12.7394,71.4039 12.7394,71.4039 C12.7394,71.4039 17.7034,54.8559 17.3654,54.3109"
              id="Fill-1248"
              fill="#F3B679"
            ></path>
            <path
              d="M17.2329,40.7098 C15.7599,41.3858 10.6709,51.1938 11.8449,52.6098 C12.3999,53.2798 17.8109,54.6978 18.7429,54.3258 C19.6749,53.9528 20.9219,44.6878 20.2549,42.5208 C19.5869,40.3528 17.2329,40.7098 17.2329,40.7098"
              id="Fill-1250"
              fill="#EEA8B7"
            ></path>
            <path
              d="M17.3653,54.3109 C17.0273,53.7659 14.1753,52.9619 13.5693,53.4019 C13.4823,53.4639 13.3273,53.8659 13.1283,54.4939 C14.2803,54.9089 15.9463,55.3379 17.1933,55.5289 C17.3453,54.8389 17.4163,54.3929 17.3653,54.3109"
              id="Fill-1252"
              fill="#D58F66"
            ></path>
            <path
              d="M11.8081,50.9161 C11.6261,51.7191 11.6121,52.3291 11.8441,52.6101 C12.3991,53.2801 17.8111,54.6981 18.7431,54.3251 C18.9351,54.2491 19.1331,53.6911 19.3281,52.8531 C17.6231,52.7711 13.1761,51.5971 11.8081,50.9161"
              id="Fill-1254"
              fill="#B55D75"
            ></path>
            <path
              d="M36.1274,68.1302 C36.0884,67.6112 36.0184,67.1832 35.9114,66.8222 C28.4654,66.9982 25.3704,72.7912 24.8174,73.9682 C25.4744,74.0812 26.1194,74.1602 26.7244,74.1942 C31.3094,67.7122 36.0994,68.1432 36.1274,68.1302"
              id="Fill-1256"
              fill="#D47087"
            ></path>
            <path
              d="M5.5329,8.7449 C5.5329,8.7449 5.6149,1.8739 6.6779,1.7919 C7.7409,1.7109 7.7419,7.2729 7.7419,7.2729 C7.7419,7.2729 11.8999,3.3649 18.3749,1.5469 C24.5749,-0.1941 33.0799,0.1319 34.0799,0.8929 C36.5029,2.7339 32.6889,5.8819 32.6889,5.8819 C32.6889,5.8819 39.4789,4.6549 40.9509,6.9449 C44.0509,11.7679 37.4559,17.4639 33.2619,18.1209 C26.7999,19.1329 20.9109,15.6159 20.9109,15.6159 C20.9109,15.6159 24.8749,20.5389 23.0359,21.4479 C19.1109,23.3859 11.0949,17.9879 11.0949,17.9879 C11.0949,17.9879 16.0029,27.7219 13.5489,30.1759 C12.1509,31.5729 8.2839,28.7199 8.2839,28.7199 C8.2839,28.7199 6.2759,30.2259 5.0419,28.2939 C1.2799,22.4049 4.5509,12.2619 4.5509,12.2619 C4.5509,12.2619 0.4619,9.8899 0.4619,8.7449 C0.4619,7.5999 5.5329,8.7449 5.5329,8.7449"
              id="Fill-1258"
              fill="#E4785D"
            ></path>
            <path
              d="M8.2837,28.7199 C8.2837,28.7199 5.6517,28.5939 5.1547,30.4529 C4.7817,31.8519 5.2937,34.1869 6.7107,34.8269 C8.1277,35.4659 10.8227,33.9209 10.8227,33.9209 L8.2837,28.7199 Z"
              id="Fill-1260"
              fill="#F3B679"
            ></path>
            <path
              d="M34.0799,0.8925 C33.0799,0.1325 24.5749,-0.1945 18.3749,1.5465 C11.8999,3.3655 7.7419,7.2725 7.7419,7.2725 C7.7419,7.2725 7.7409,1.7105 6.6779,1.7925 C5.6149,1.8745 5.5329,8.7445 5.5329,8.7445 C5.5329,8.7445 0.4619,7.5995 0.4619,8.7445 C0.4619,9.8905 4.5509,12.2625 4.5509,12.2625 C4.5509,12.2625 3.1049,16.7525 3.2439,21.4925 C5.9129,13.2645 6.9139,13.1855 8.8689,10.9195 C10.8009,8.6795 18.2529,3.2875 34.7639,3.0845 C35.0019,2.3205 34.9169,1.5285 34.0799,0.8925"
              id="Fill-1262"
              fill="#C66853"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "BoyIcon",
  props: ["width", "height"],
};
</script>

<style>
</style>